module.exports = __webpack_public_path__ + "static/media/award_blue.b6c7b73a.svg";